<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Archivo adjunto</span
            >
            <button
                mat-icon-button
                aria-label="Close dialog"
                (click)="dialogRef.close()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <object
            *ngIf="archivo"
            [data]="archivo"
            style="width: 100%; height: 60vh"
        ></object>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button mat-dialog-close color="accent">
            Cerrar
        </button>
    </mat-dialog-actions>
</div>
